// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f74e3b0f","488":"fe9ca9c6","977":"5a3f8e8f"}[chunkId] + ".chunk.js";
};